<template>
  <md-toolbar
    md-elevation="0"
    class="md-transparent fmToolbar"
    :class="{
      'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute,
    }"
  >
    <div class="md-toolbar-row">
      <div class="md-toolbar-section-start">
        <h3
          class="md-title"
          data-tour="channel_card_pattern"
          v-if="$route.name == 'Channel Config'"
        >
          {{
            $route.name +
            " " +
            " for Channel ID Pattern: " +
            channel.channelIdPattern
          }}
        </h3>
        <h3 class="md-title" v-else>
          {{ $route.name }}
        </h3>
      </div>
      <search-input></search-input>

      <div class="md-toolbar-section-end">
        <!--
          This is the sidebar toggle (top navbar displayed for small screens).
        -->
        <md-button
          class="md-just-icon md-round md-simple md-toolbar-toggle"
          :class="{ toggled: $sidebar.showSidebar }"
          @click="toggleSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <!--
          This is the top navbar displayed for larger screens.
        -->
        <div class="md-collapse">
          <md-list>
            <md-list-item>
              <div id="my-widget"></div>
            </md-list-item>
            <md-list-item
              id="top-nav-tools"
              class="dropdown"
              data-cy="user_down_down"
            >
              <drop-down>
                <md-button
                  slot="title"
                  class="dropdown-toggle md-simple md-small"
                  data-tour="top_dropdown"
                  data-toggle="dropdown"
                >
                  {{ dropDownLabel }}
                </md-button>
                <md-list class="dropdown-menu dropdown-menu-right">
                  <md-list-item
                    :md-ripple="false"
                    :class="{ selected: isActive(billingHref) }"
                    :href="billingHref"
                    data-tour="top_billing"
                    class="
                      nav-link nav-item
                      active
                      router-link-active
                      simple-text
                    "
                  >
                    <div class="md-layout">
                      <div class="md-layout-item md-size-20">
                        <md-icon>credit_card</md-icon>
                      </div>
                      <div class="md-layout-item md-size-80">
                        <span class="md-list-item-text" data-cy="billing">
                          Billing
                        </span>
                      </div>
                    </div>
                  </md-list-item>
                  <md-list-item
                    :md-ripple="false"
                    :class="{ selected: isActive(logoutHref) }"
                    :href="logoutHref"
                    data-tour="top_logout"
                    @click="logoff"
                    class="
                      nav-link nav-item
                      active
                      router-link-active
                      simple-text
                    "
                  >
                    <div class="md-layout">
                      <div class="md-layout-item md-size-20">
                        <md-icon>arrow_right_alt</md-icon>
                      </div>
                      <div class="md-layout-item md-size-80">
                        <span class="md-list-item-text" daya-cy="logout">
                          Logout
                        </span>
                      </div>
                    </div>
                  </md-list-item>
                </md-list>
              </drop-down>
            </md-list-item>
          </md-list>
        </div>
      </div>
    </div>
    <search-modal></search-modal>
  </md-toolbar>
</template>
<script>
import { logout } from "../../../utils/auth0";
import { globalSelectedApp } from "../../../utils/global";
import { get } from "vuex-pathify";
import { generateAppToken } from "../../../utils/appcues";
import api from "@/api";
import SearchModal from "@/components/Cards/SearchModal";
import SearchInput from "@/components/Inputs/SearchInput";

export default {
  async mounted() {
    var me = this;
    var script = document.createElement("script");
    script.setAttribute("type", "text/javascript");
    script.innerHTML = // Done this way since the widget belongs to appcues, so we interact with it directly.
      "\
      function toggleChecklist() { \
        var link = document.getElementById('checklistLink');\
        if (link.dataset.state == 'Opener') {\
          Appcues.show('-MOJ780ZzTSiQx7eN_0y');\
          link.dataset.state = 'Closer';\
          link.innerHTML = 'Close Getting Started Checklist'\
        } else {\
          Appcues.clearShow();\
          link.dataset.state = 'Opener';\
          link.innerHTML = 'Open Getting Started Checklist'\
        }\
      }\
      ";
    document.getElementsByTagName("head")[0].appendChild(script);
    me.loadWidget();
  },

  props: {
    organization: {},
  },
  data() {
    return {
      billingHref: "#/billing",
      logoutHref: "#",
      codePenLink: "",
      appToken: { value: null }, // Token used in the CodePen link
    };
  },
  computed: {
    dropDownLabel: function () {
      if (this.organization && this.organization.name) {
        return this.organization.name;
      }
      if (this.organization.primaryContact) {
        if (
          this.organization.primaryContact.firstName &&
          this.organization.primaryContact.lastName
        ) {
          return `${this.organization.primaryContact.firstName} ${this.organization.primaryContact.lastName}`;
        }
        if (this.organization.primaryContact.firstName) {
          return this.organization.primaryContact.firstName;
        }
        if (this.organization.primaryContact.lastName) {
          return this.organization.primaryContact.lastName;
        }
      }
      return "";
    },
    apps: get("applications/entities") || [],
    channel: get("channels/loadedEntity"),
  },
  components: {
    "search-modal": SearchModal,
    "search-input": SearchInput,
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
    logoff() {
      logout();
    },
    isActive(link) {
      if (link.startsWith("#")) {
        link = link.substring(1);
      }

      if (this.$route && this.$route.path) {
        return this.$route.path === link;
      }
      return false;
    },
    generateCodePenLink() {
      var me = this;
      return new Promise((resolve, reject) => {
        me.$store.dispatch("applications/loadEntities").then(() => {
          if (globalSelectedApp != undefined) {
            generateAppToken(
              globalSelectedApp.applicationId,
              globalSelectedApp.sharedSecret,
              me.appToken
            ).then(() => {
              resolve();
            });
          } else {
            reject();
          }
        });
      });
    },
    loadWidget() {
      var me = this;
      var gatewayUrl = api.props.config.codepenGatewayUrl;
      me.generateCodePenLink().then(
        () => {
          "https://codepen.io/frznmtn/pen/abbxYpe?token=" +
            me.appToken.value +
            "&appId=" +
            globalSelectedApp.applicationId +
            "&gwUrl=" +
            gatewayUrl;
          let widget = AppcuesWidget(Appcues.user()); // eslint-disable-line
          widget.init("#my-widget", {
            position: "left",
            footer:
              '<a target="_blank" id="bellCodepenLink" rel="noopener noreferrer" href="' +
              me.codePenLink +
              '">Try a Test Call</a><br>' +
              `<a id="checklistLink" data-state="Opener" href="javascript:toggleChecklist()">Open Getting Started Checklist</a>`,
          });
        },
        () => {
          console.log(
            "Failed to create CodePen link. Try checking you have an active subscription and try again."
          );
        }
      );
      var widgetElement = document.getElementById("my-widget");
      widgetElement.addEventListener("click", () => {
        let me = this;
        me.generateCodePenLink().then(
          () => {
            me.codePenLink =
              "https://codepen.io/frznmtn/pen/abbxYpe?token=" +
              me.appToken.value +
              "&appId=" +
              globalSelectedApp.applicationId +
              "&gwUrl=" +
              gatewayUrl;
            document
              .getElementById("bellCodepenLink")
              .setAttribute("href", me.codePenLink);
          },
          () => {
            console.log(
              "Failed to create CodePen link. Try checking you have an active subscription and try again."
            );
          }
        );
      });
    },
  },
};
</script>
<style lang="scss">
@import "../../../assets/scss/md/_variables.scss";
@import "../../../assets/scss/md/_mixins.scss";
@import "../../../assets/scss/md/_shadows.scss";
@import "../../../assets/scss/fm/_searchbar.scss";

#top-nav-tools button {
  background-color: inherit !important;
  color: inherit !important;
  overflow: visible;
}
#top-nav-tools button:after {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 5px;
  width: 1px;
  height: 100%;
  background-color: rgba(180, 180, 180, 0.3);
}
#top-nav-tools ul {
  padding: 10px 0;
  background-color: #ffffff !important;
}
#top-nav-tools ul li {
  margin: 0;
}
#top-nav-tools a {
  padding: 0;
  margin: 0;
}
#top-nav-tools a .md-list-item-text {
  padding-top: 5px;
  line-height: 1.3em;
}
#top-nav-tools a .md-list-item-content {
  min-height: 35px;
  padding: 5px 0 5px;
}
#top-nav-tools .dropdown-menu .active > a {
  background-color: #ffffff !important;
  color: inherit !important;
  -webkit-box-shadow: none;
  box-shadow: none;
}
#top-nav-tools .dropdown-menu .active > a:hover {
  background-color: #e8e8e8 !important;
}
#top-nav-tools .dropdown-menu .active.selected > a {
  background-color: #262d42 !important;
}
#top-nav-tools .dropdown-menu .active.selected > a .md-list-item-content,
#top-nav-tools .dropdown-menu .active.selected > a .md-icon {
  color: #ffffff !important;
}

.dropdown-menu {
  width: 120px;
  min-width: 150px;
}
.dropdown-menu.dropdown-menu-right {
  right: 35px;
}
.md-toolbar .md-list .md-list-item.dropdown .md-button-clean,
.md-toolbar .md-list .md-list-item.dropdown .md-list-item-content.md-ripple {
  overflow: visible;
}
.md-list-item {
  z-index: 3;
}
/* Appcues widget properties */
a[data-itemid] time {
  display: none;
}
.appcues-widget-dropdown {
  border-radius: 3px;
  padding-left: 0px !important;
  padding-right: 0px !important;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
}
.appcues-widget-dropdown.appcues-widget-left::after {
  display: none !important;
}
.appcues-widget-dropdown .appcues-widget-content {
  overflow-y: hidden !important;
}
.appcues-widget-list {
  padding: 0px;
  li {
    padding: 10px !important;
  }
}
.appcues-widget-footer {
  padding-left: 10px;
  padding-top: 7px;
  padding-bottom: 5px;
  a {
    line-height: 1.9em;
    font-size: 14px;
  }
}
/* End Appcues widget properties */
</style>

<style scoped>
.fmToolbar {
  z-index: auto;
}
</style>
